export const zIndexMin = -(Math.pow(2, 31) - 1);
export const zIndexBackground = -99;
export const zIndexForeground = 100;
export const zIndexSticky = 200;
export const zIndexFixed = 400;
export const zIndexModal = 1000;
export const zIndexAlert = 10000;
export const zIndexPopovers = 100000;
//# sourceMappingURL=zIndex.js.map